export const PORTFOLIO_TRANSITION_DURATION = 1.4
export const PORTFOLIO_TRANSITION_DURATION_MS = PORTFOLIO_TRANSITION_DURATION * 1000
export const PORTFOLIO_SINGLE_TRANSITION_OUT_DURATION = PORTFOLIO_TRANSITION_DURATION * 0.25

export const PAGE_TRANSITION_DURATION = 1.6
export const PAGE_TRANSITION_DURATION_MS = PAGE_TRANSITION_DURATION * 1000
